import event from '../../event/event';

export default event('/layout/not-implemented');
